import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import { Popup } from '../../utils/popups';
import { AbstractPopup } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
function ToastPopup({ message, reject, resolve }) {
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            resolve();
        }, 2000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [resolve]);
    return (_jsx(ToastPopupRoot, { reject: reject, children: _jsx(ToastMessage, { children: message }) }));
}
const ToastMessage = styled.div `
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
`;
const ToastPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Y: 2rem;
    --Popup_BorderRadius: 0.75rem;
    --Popup_Width: auto;
    --Popup_Padding: 0.75rem 1.5rem;
    --Popup_Duration: 300ms;
`;
const toastPopup = Popup.create(ToastPopup);
export function showToast(message) {
    (async () => {
        try {
            await toastPopup.pop({ message });
        }
        catch (_) { }
    })();
}
